export const GroupConst = {
   limitselect: [
      {id: 0, text: "None"},
      {id: 1, text: "Without CCA"},
      {id: 2, text: "Invitation"},
   ],
   eventdayselect: [
      {dow: 1, day: "Monday"},
      {dow: 2, day: "Tuesday"},
      {dow: 3, day: "Wednesday"},
      {dow: 4, day: "Thursday"},
      {dow: 5, day: "Friday"},
   ],
   yearselect: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13"],
};

export const UserType = {
   STAFF: 0,
   VENDOR: 1,
   PARENT: 2,
   STUDENT: 3,
   TRANSPORTER: 4,
};

export const Attendance = {
   ABSENT: 0,
   PRESENT: 1,
   NA: -1,
};

export const SubscriptionType = {
   TYPE_SUBSCRIPTION: 1,
   TYPE_INVITATION: 2,
};

export const NAME_MAXLENGTH = 100;
export const DESCRIPTION_MAXLENGTH = 1024;
